import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            主题索引
          </h2>
          <p className="text-sm text-foreground-600">按分类浏览每日大赛全集内容，快速找到感兴趣的赛事</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="flex items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.count}</p>
              </div>
              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-hover:text-primary-500 transition-colors ml-auto">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}